(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ScrollToTop from "../components/scroll-to-top";
import Header from '../components/Header';
import FormContact from '../components/form-contact';
import { Helmet } from "react-helmet";
import { Link } from 'react-router-dom';
import mosaic from '../assets/static/mosaic.svg';
import { NEXT_PUBLIC_PHONE_COMPANY, NEXT_PUBLIC_ADDRESS_COMPANY, NEXT_PUBLIC_ZIPCODE_COMPANY, NEXT_PUBLIC_CITY_COMPANY } from '../utils/utilities';

class Neighborhood extends React.Component {
  render() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("title", null, "Contact Us"), /*#__PURE__*/React.createElement("meta", {
      name: "description",
      content: `The District Contact Us. 1144-1150 W. 28th Street, Los Angeles, CA 90007. Phone: ${NEXT_PUBLIC_PHONE_COMPANY}`
    })), /*#__PURE__*/React.createElement(ScrollToTop, null), /*#__PURE__*/React.createElement(Header, {
      mode: "nobg"
    }), /*#__PURE__*/React.createElement("div", {
      id: "content",
      className: "bypass-block-target",
      tabIndex: "-1"
    }, /*#__PURE__*/React.createElement(Container, {
      className: "content topc"
    }, /*#__PURE__*/React.createElement("h1", {
      className: "h1 mb-5 biglinehd"
    }, /*#__PURE__*/React.createElement("span", null, "Contact Us")), /*#__PURE__*/React.createElement(Row, {
      className: "rowfooter"
    }, /*#__PURE__*/React.createElement(Col, {
      sm: 6
    }, /*#__PURE__*/React.createElement(FormContact, null)), /*#__PURE__*/React.createElement(Col, {
      sm: 6
    }, /*#__PURE__*/React.createElement("img", {
      src: "/images/logo.png",
      alt: "The District",
      className: "mb-4",
      width: 270,
      height: 65
    }), /*#__PURE__*/React.createElement("div", {
      className: "d-flex justify-content-between align-items-center dflexfooter mb-4"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, NEXT_PUBLIC_ADDRESS_COMPANY, ", ", /*#__PURE__*/React.createElement("br", null), NEXT_PUBLIC_CITY_COMPANY, ", ", NEXT_PUBLIC_ZIPCODE_COMPANY), /*#__PURE__*/React.createElement("p", null, "Phone: ", NEXT_PUBLIC_PHONE_COMPANY), /*#__PURE__*/React.createElement("p", {
      className: "mb-0"
    }, "Contact Hours", /*#__PURE__*/React.createElement("br", null), "Monday \u2013 Friday 10 AM to 5 PM", /*#__PURE__*/React.createElement("br", null), "Saturday & Sunday Closed")), /*#__PURE__*/React.createElement("div", {
      className: "devby text-center"
    }, /*#__PURE__*/React.createElement("p", {
      className: "mb-0"
    }, "Developed and Managed by:"), /*#__PURE__*/React.createElement("img", {
      src: mosaic,
      alt: "Mosaic Student Communities",
      width: "148",
      height: "123"
    }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 6,
      className: "mb-3"
    }, /*#__PURE__*/React.createElement(Link, {
      to: "/floorplans",
      className: "btn btn-secondary btn-block"
    }, "Apply Now")), /*#__PURE__*/React.createElement(Col, {
      sm: 6,
      className: "mb-3"
    }, /*#__PURE__*/React.createElement("a", {
      href: "https://mosaicstudent.appfolio.com/connect/users/sign_in?a=cw&utm_source=apmsites_v3&utm_campaign=pay_rent_button",
      target: "_blank",
      className: "btn btn-secondary btn-block"
    }, "Pay Rent"))), /*#__PURE__*/React.createElement("a", {
      href: "https://mosaicstudent.appfolio.com/connect/users/sign_in?a=cw&utm_source=apmsites_v3&utm_campaign=tportal_login",
      target: "_blank",
      className: "btn btn-secondary btn-block"
    }, "Maintenance Request"))))), /*#__PURE__*/React.createElement("div", {
      className: "lastfooter"
    }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("a", {
      href: "#"
    }, "Student Housing Design by IT49 Multimedia"))));
  }

  // @ts-ignore
  __reactstandin__regenerateByEval(key, code) {
    // @ts-ignore
    this[key] = eval(code);
  }

}

const _default = Neighborhood;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Neighborhood, "Neighborhood", "/var/www/html/websites/thedistrictusc-com/src/frontend/pages/contact.jsx");
  reactHotLoader.register(_default, "default", "/var/www/html/websites/thedistrictusc-com/src/frontend/pages/contact.jsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();